import React from "react";
import { Link } from "react-router-dom";



const Base = ({
    title = "My Title",
    description = "My desription",
    className = "  p-4",
    children
}) => {




    return (
        <div >


            <div className="container-fluid">
                <div className="text-center">
                    <Link to="/">  <h1 className="text-success display-4 font-weight-bold">{title}</h1></Link>
                    <br></br>
                    <p className=" text-white lead">{description}</p>
                </div>
                <div>{children}</div>
            </div >


            <footer className="footer mt-auto py-3">
                <div className="container-fluid bg-success text-center py-3">
                    <h4 className="text-white">If you got any questions, feel free to reach out!</h4>
                    <Link to="/contact"> <button className="btn btn-warning btn-lg">Contact Us</button></Link>
                </div>
                <div className="container">
                    <span className="text-muted">
                        <p>  Your data won't be shared  to anyone. </p>
                    </span>
                </div>
            </footer>
        </div >
    )
}

export default Base;
